<div class="col-xs-4 col-md-4 col-centered col-slider no-padding row">
  <freighter-client-form [freighter]="freighter" [client]="client" (back)="onBack()" (saved)="onSaved($event)"></freighter-client-form>
</div>
